import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const fileUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  const full = `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url.startsWith('/api/storage/') ? `${full}?auth=${localStorage.getItem('token')}` : full;
};
